'use strict';

var Bacon, R, mapFliped, nameable, translate, translateCartItem, translateCartItemModifier, translateCartItemsStream, translateCategories, translateChoiceDefinition, translateGQLItemStream, translateGQLMenuStream, translateItem, translateItem5, translateItemStream, translateMenuStream, translateMenus, translateModifier5, translateModifierDefinition, translateOption5, translateSize, translateSize5, translations, translationsStream;

Bacon = require('baconjs');

R = require('ramda');

translationsStream = new Bacon.Bus();

translations = translationsStream.toProperty({
  __count: 0
});

translate = R.curry(function (translations, text) {
  if (text && text.trim().length && translations[text.trim()]) {
    return translations[text.trim()];
  } else {
    return text;
  }
});

nameable = function nameable(t) {
  return {
    name: t,
    description: t
  };
};

mapFliped = R.flip(R.map);

//####### Menu ##########
translateCategories = function translateCategories(t) {
  return R.merge(nameable(t), {
    items: R.map(R.evolve(nameable(t)))
  });
};

translateMenus = function translateMenus(t) {
  return R.merge(nameable(t), {
    categories: R.map(R.evolve(translateCategories(t)))
  });
};

translateMenuStream = function translateMenuStream(menus) {
  return translations.map(translate).map(R.compose(mapFliped(menus), R.evolve, translateMenus));
};

//###### GQL Menu ########
translateGQLMenuStream = function translateGQLMenuStream(menus) {
  return translations.map(function (translations) {
    var t;
    if (translations.__count > 0) {
      t = translate(translations);
      return R.compose(mapFliped(menus), R.evolve, translateMenus)(t);
    } else {
      return menus;
    }
  });
};

//###### GQL Item ########
translateGQLItemStream = function translateGQLItemStream(item) {
  return translations.map(function (translations) {
    var t;
    if (translations.__count > 0) {
      t = translate(translations);
      return R.evolve(translateItem5(t), item);
    } else {
      return item;
    }
  });
};

translateItem5 = function translateItem5(t) {
  return R.merge(nameable(t), {
    sizes: R.map(R.evolve(translateSize5(t)))
  });
};

translateSize5 = function translateSize5(t) {
  return R.merge(nameable(t), {
    modifiers: R.map(R.evolve(translateModifier5(t)))
  });
};

translateModifier5 = function translateModifier5(t) {
  return R.merge(nameable(t), {
    options: R.map(R.evolve(translateOption5(t)))
  });
};

translateOption5 = function translateOption5(t) {
  return R.merge(nameable(t), {
    group_label: t
  });
};

//####### Item ###########
translateItem = function translateItem(t) {
  return R.merge({
    sizes: R.map(R.evolve(translateSize(t))),
    choices_definitions: R.map(R.evolve(translateChoiceDefinition(t)))
  }, nameable(t));
};

translateSize = function translateSize(t) {
  return {
    size_name: t
  };
};

translateChoiceDefinition = function translateChoiceDefinition(t) {
  return R.merge({
    modifiers_definitions: R.map(R.evolve(translateModifierDefinition(t)))
  }, nameable(t));
};

translateModifierDefinition = function translateModifierDefinition(t) {
  return R.merge(nameable(t), {
    group_label: t
  });
};

translateItemStream = function translateItemStream(item) {
  return translations.map(translate).map(function (t) {
    return R.evolve(translateItem(t), item);
  });
};

//###### CART ITEM ##########
translateCartItem = function translateCartItem(t) {
  return R.merge({
    size: t,
    modifiers: R.map(R.evolve(translateCartItemModifier(t)))
  }, nameable(t));
};

translateCartItemModifier = function translateCartItemModifier(t) {
  return {
    choice_name: t,
    name: t
  };
};

translateCartItemsStream = function translateCartItemsStream(items) {
  return translations.map(translate).map(R.compose(mapFliped(items), R.evolve, translateCartItem));
};

module.exports = {
  useTranslationStream: function useTranslationStream(translations$) {
    return translationsStream.plug(translations$);
  },
  translateItem: translateItemStream,
  translateMenu: translateMenuStream,
  translateGQLMenu: translateGQLMenuStream,
  translateGQLItem: translateGQLItemStream,
  translateCartItems: translateCartItemsStream
};